export default __webpack_public_path__ + "6950287076ab31f240b4f1a63f963803.png";